// @flow

import type { Action } from 'app/common/redux/types';

export type State = {
  contentSafetyModalViewed: boolean,
};

const initialState = {
  contentSafetyModalViewed: false,
};

const contentSafetyModal = (state: State = initialState, action: Action): State => {
  if (action.type === 'CONTENT_SAFETY_MODAL_VIEWED') {
    return {
      // ...state,
      contentSafetyModalViewed: action.payload.content_safety_modal_viewed,
    };
  }
  return state;
};

export default contentSafetyModal;
